import { Box } from '@chakra-ui/react';
import type { SingleValue } from 'react-select';

import { StyledPlotSelect } from '../StyledPlotSelect';

type NumOfNodesOption = {
  value: number;
  label: string;
};

type SankeyFooterProps = {
  numOfNodes: number;
  onNumOfNodesChange: (value: number) => void;
  options: number[];
};

export const SankeyFooter = ({
  numOfNodes,
  onNumOfNodesChange,
  options,
}: SankeyFooterProps) => {
  const numOfNodeOptions: NumOfNodesOption[] = options.map((value) => ({
    value,
    label: `${value}`,
  }));

  const numOfNodesValue: NumOfNodesOption = {
    value: numOfNodes,
    label: `${numOfNodes}`,
  };

  const onChange = (value: SingleValue<NumOfNodesOption>) => {
    if (value) {
      onNumOfNodesChange(value.value);
    }
  };

  return (
    <Box position="absolute" right="0" bottom="0">
      <StyledPlotSelect
        value={numOfNodesValue}
        onChange={onChange}
        options={numOfNodeOptions}
        menuPlacement="top"
        getOptionLabel={(option) => `Show ${option.label}`}
      />
    </Box>
  );
};
